import React, { useState, useRef, useEffect } from "react";
import { uploadDocument } from "../../../redux/slices/DocumentsSlice";
import { useAppDispatch, useAppSelector } from "../../../redux/store/store";
import moment from "moment";
import { IUpload } from "../../../types/Document";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "../../../components/core/UploadDocument/UploadDocument.css";
import {
  handleSwalMessage,
} from "../../../Helpers/Http.commons";
import { refreshToken2 } from '../../../refreshToken2';
import { useMsal } from '@azure/msal-react';
import { fetchPullRepositorysById } from "../../../redux/slices/RepositorysSlice";
import Spinner from "../../Spinner/Spinner";
import { IRepositoryFilter } from "../../../types/RepositoryFilters";

type InputListItem = { key: string; value: string };
const repositoryName = sessionStorage.getItem("repositoryName");
const UploadDocument = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const formData = new FormData();
  const [inputList, setinputList] = useState([{ key: "", value: "" }]);
  const [currentMetadata, setCurrentMetadata] = useState({ key: "", value: "" });
  const [loading, setLoading] = useState(false);
  const [upload, setUpload] = useState<IUpload>({
    base64Document: "",
    path: "documents",
    fileName: "",
    description: "",
    createdAt: new Date(),
    classification: "",
    accessFrequency: "intelligent",
    metadata: [
      {
        key: "",
        value: "",
      },
    ],
    repositoryName: `${repositoryName}`,
  });
  const result = useAppSelector((state) => state.DocumentsSlice.result || []);
  const repositoryDataResponse: IRepositoryFilter = useAppSelector(
    (state) => state.RepositorysSlice.resultado
  ) || {
    id: "",
    name: "",
    description: "",
    businessUnitId: "",
    businessUnitName: "",
    businessUnitCostCenter: "",
    businessUnitResponsible: "",
    filters: [],
  };
  const { instance } = useMsal();
  const repositoriID = sessionStorage.getItem("repositoryId");
  const [baseImage, setBaseImage] = useState("");
  const [filename, setFileName] = useState("");
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);

  useEffect(() => {
    setLoading(true);
    loadContent();
    setLoading(false);
  }, [repositoriID]);

  const loadContent = async () => {
    await refreshToken2(instance);
    await dispatch(fetchPullRepositorysById(repositoriID ?? ""));
    if (repositoryDataResponse && repositoryDataResponse.filters) {
      setSelectedOptions(repositoryDataResponse.filters);
    } else {
      console.log("no hay metadata (REDUX)");
      console.log("repositoryID: "+repositoriID);
      console.log("repositoryDataResponse.filters: "+repositoryDataResponse.filters);
      
    }
  };

  const handleDragOver = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const uploadImage = async (e: any) => {
    e.preventDefault();
    const file = e.target.files && e.target.files[0];
    const fileSize = file && file.size;
    const fileSizeLimit = 5000000;
    if (fileSize && fileSize > fileSizeLimit) {
      e.target.value = "";
      Swal.fire({
        icon: "error",
        title: "Error al subir el documento",
        text: `El documento seleccionado es demasiado grande. El tamaño máximo permitido es de ${
          fileSizeLimit / 1000000
        } MB.`,
      });
    } else {
      const fileSizeInMB = fileSize && (fileSize / 1000000).toFixed(2);
      Swal.fire({
        icon: "success",
        title: "Archivo seleccionado con éxito",
        text: `El archivo ha sido seleccionado con éxito. El tamaño del archivo es: ${fileSizeInMB} MB.`,
      });
      const decodedFilename = decodeURIComponent(file.name);
      setFileName(decodedFilename);
      const base64: any = await convertBase64(file);
      var solution = base64.split("base64,")[1];
      setBaseImage(solution);
    
      setUpload({
        ...upload,
        fileName: decodedFilename,
        base64Document: solution,
      });
    }
  };


  const handleValidation = () => {
    const {
      base64Document,
      path,
      description,
      classification,
      repositoryName,
      metadata,
    } = upload;
    if (!base64Document) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Por favor seleccione un archivo a subir",
      });
      return false;
    }
  
    if (!path) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Por favor ingrese una ruta de almacenamiento",
      });
      return false;
    }
  
    if (!description) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Por favor ingrese una descripción del documento",
      });
      return false;
    }
  
    if (!classification) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Por favor seleccione una clasificación del documento",
      });
      return false;
    }
    if (!repositoryName) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Nombre de repositorio no cargado en el formulario intentelo nuevamente",
      });
      return false;
    }if (!metadata) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No has ingresado la metadata asociada al documento",
      });
      return false;
    }
  
    return true;
  };

  

  const convertBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const handleDrop = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      uploadImage({ target: { files: e.dataTransfer.files } });
    }
  };

  const updateListItem = (
    list: InputListItem[],
    index: number,
    myKey: string,
    myValue: string
  ) => {
    list[index] = {key: myKey, value: myValue};
    return list;
  };

  function validateField(value: string, regex: RegExp) {
    return regex.test(value);
  }

  const handleInputChange = (
    event: any,
    position: number
  ) => {
    
    let currentValue = event.target.value;
    // console.log("inputList 1:"+JSON.stringify(inputList));
    const list = [...inputList] as InputListItem[];
    const isNameValid = validateField(
      event.target.value,
      /^[a-zA-Z0-9-]+$/u
    );
    if (isNameValid) {
      if (event.target.type == "select-one") {
        let tempValue = list[position].value;
        setinputList(updateListItem(list, position, currentValue, tempValue));
        inputList

      } else {
        let tempValue = list[position].key;
        setinputList(updateListItem(list, position, tempValue, currentValue));
      }
      // console.log("inputList 2:"+JSON.stringify(inputList));
    }
  };


  const handleremove = (e: any, index: any) => {
    const list = [...inputList];
    // console.log("inputList 1:"+JSON.stringify(inputList));
    list.splice(index, 1);
    setinputList(list);
    // console.log("inputList 2:"+JSON.stringify(inputList));
    e.preventDefault();
  };

  const isValidInputList = (
    e: any,
    list: InputListItem[], 
    index: any
  ) => {
    let tempReturn = true;
    if (list.length > 10) {
      Swal.fire({
        icon: "warning",
        title: "Oops...",
        text:
          "Has llegado al límite de items",
      });
      tempReturn = false;
    } 
    if ( list[index].key.length == 0 ||
      list[index].value.length == 0) {
      Swal.fire({
        icon: "warning",
        title: "Oops...",
        text:
          "Debes ingresar los valores: llave y valor",
        });
      tempReturn = false;
    }
    e.preventDefault();
    return tempReturn;
  };

  const handleaddclick = (e: any, index: any) => {
    try {
      if (isValidInputList(e, inputList, index)) {
        setinputList([...inputList, { key: "", value: "" }]);
        setUpload({
          ...upload,
          metadata: inputList,
        });
        e.preventDefault();
      }
    } catch (error) {
      console.error(error);
    }
  };

  async function handleSubmit(
    e: any,
    setinputList: React.Dispatch<React.SetStateAction<InputListItem[]>>
  ) {

    e.preventDefault();
    if (!handleValidation()) {
      return;
    }else {
    const date = moment().format("YYYY-MM-DDTHH:mm:ss");
    const datee = new Date(date);
    const {
      fileName,
      base64Document,
      path,
      description,
      classification,
      accessFrequency,
      repositoryName,
    } = upload;
    setinputList(inputList);
    setUpload({
      ...upload,
      metadata: inputList,
    });
    setUpload({
      fileName,
      base64Document,
      path,
      description,
      classification,
      accessFrequency,
      repositoryName,
      createdAt: datee,
      metadata: inputList,
    });
    formData.append("json", JSON.stringify(upload));
    // console.log(upload);
    await dispatch(uploadDocument(upload))
      .then((responseData) => {
        if (uploadDocument.fulfilled.match(responseData)) {
          const { statusCode, error } = responseData.payload;
          const message = "Documento cargado con exito";
          const swalData: any = handleSwalMessage(
            responseData.payload,
            error || message
          );
          Swal.fire(swalData);
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text:
            error.message ||
            "Hubo un error al cargar el documento. Por favor, inténtalo de nuevo más tarde.",
        });
        console.error("Error al cargar el documento:", error);
      });

    resetFields();
    console.log('============ REDIRECT LOG: [UploadDocument] - Navigate to /documents?refresh=true');
    navigate({
      pathname: '/documents',
      search: '?refresh=true',
    });
  }
  }

  const resetFields = () => {
    // setUpload({ fileName: '', base64Document: '', path: '', description: '', classification: '', accessFrequency: '', repositoryName: '', metadata: [] });
    setinputList([{ key: "", value: "" }]);
  };

  // const handleInputClick = () => {
  //   fileInputRef.current.click();
  // };

  const renderMetadataFilters = () => {
    if (!selectedOptions) return null;

    return (
      <div>
        <table className="pds-table ">
          <thead>
            <strong>Metadata</strong>
            <tr>
              <th>Key</th>
              <th>Value</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {inputList.map((x, i) => (
              <tr key={i}>
                <td>
                  <select
                    id={`filter-select-${i}`}
                    name="select-input"
                    onChange={(e) => handleInputChange(e, i)}
                    className="form-control"
                  >
                    <option value="" hidden selected>
                      Selecciona una metadata
                    </option>
                    {Object.values(selectedOptions).map(
                      (repository: any, index) => (
                        <option key={`filter-option-${index}`} value={repository}>
                          {repository}
                        </option>
                      )
                    )}
                  </select>
                </td>
                <td>
                  <input
                    type="text"
                    name="value"
                    value={x.value}
                    onChange={(e) => handleInputChange(e, i)}
                    pattern="^[a-zA-Z0-9-]+$"
                    className="pds-validation"
                    minLength={2}
                    maxLength={16}
                  />
                </td>
                {/* <td>
                  {inputList.length !== 1 && inputList.length -1 > i &&(
                    <button
                      className="pds-button pds-button-tertiary"
                      onClick={(e) => handleremove(e, i)}
                    >
                      X
                    </button>
                  )}
                </td> */}
                <td>
                  {inputList.length - 1 === i && (
                    <button
                      className="pds-button pds-button-tertiary"
                      onClick={(e) => handleaddclick(e,i)}
                    >
                      Agregar Metadata
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };


  return loading ? (
    <Spinner />
  ) : (
    <div className="pds-form" style={{ maxWidth: 700 }}>
      <div className="pds-card pds-productCard productcard-deleted">
        <div
          className="pds-card-section pds-card-bg-primary-blue-2"
          tabIndex={0}
        >
          <h3 className="pds-card-title pds-typography-truncate">
            &nbsp;Carga de Documentos
          </h3>
          <p className="pds-typography-body-14">
            (*) Para cargar un documento favor sube un archivo y rellena el
            formulario.
          </p>
        </div>
        <div className="pds-card-section">
          <dl className="pds-gridTable" tabIndex={0}>
            <div className="row">
              <form
                id="document-upload-form"
                data-gtm-form="pdsFormValidation"
                name="pdsFormValidation"
                className="pds-form-wrapper pds-form-enable-validations"
                action="#"
              >
                <div className="pds-form-field document-form-upload">
                  <div className="row">
                    <div className="col-12">
                      <label className="drop-container">
                        <input
                          type="file"
                          accept="application/pdf,.png,.txt,.svg,image/*"
                          required
                          data-file-size="5000000"
                          onChange={uploadImage}
                          onDragOver={handleDragOver}
                          onDrop={handleDrop}
                          ref={fileInputRef}
                          name="file-1"
                          id="file-1"
                          className="hidden-accessible inputfile inputfile-1"
                          data-multiple-caption="{count} files selected"
                          multiple
                        />
                        <label htmlFor="file-1">
                          <strong>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={20}
                              height={17}
                              viewBox="0 0 20 17"
                            >
                              <path d="M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z" />
                            </svg>
                            Seleciona un archivo
                          </strong>
                        </label>
                        <div>
                          {filename ? (
                            <div className="col-12 ">
                              {`Este es tu archivo cargado ${filename}`}
                            </div>
                          ) : (
                            <div className="col-12">
                              No has cargado ningún archivo aún
                            </div>
                          )}
                        </div>
                        &nbsp;
                      </label>
                      &nbsp;
                    </div>
                    &nbsp;
                    <div className="pds-labeledInput">
                      <label
                        htmlFor="pdsFormValidation-labeledInputId"
                        className="pds-label"
                        id="document-directory-text"
                      >
                        Ingresa el directorio (Opcional, si no se ingresa se
                        utilizará valor por defecto: documents )
                        <span className="pds-label-required" aria-hidden="true">
                          *
                        </span>
                      </label>
                      <input
                        id="document-input-directory"
                        aria-label=""
                        onChange={(e) =>
                          setUpload({ ...upload, path: e.target.value })
                        }
                        type="text"
                        className="pds-validation"
                        aria-required="true"
                      />
                    </div>
                    
                  </div>
                </div>
                <div className="pds-form-field">
                  <div className="pds-erroredInput">
                    <div className="pds-labeledInput">
                      <label
                        htmlFor="pdsFormValidation-helperInput"
                        className="pds-label"
                        id="document-description-text"
                      >
                        Ingrese descripcion del archivo
                        <span className="pds-label-required" aria-hidden="true">
                          *
                        </span>
                      </label>
                      <input
                        id="document-description-file"
                        aria-label=""
                        type="text"
                        onChange={(e) =>
                          setUpload({ ...upload, description: e.target.value })
                        }
                        className="pds-validation"
                        aria-describedby="helper-text-id"
                        required
                        aria-required="true"
                        min={18}
                      />
                    </div>
                    <div className="pds-error">
                      <span
                        className="pds-util-flex-align-center"
                        id="pdsFormValidation-error-example-id"
                        tabIndex={0}
                      >
                        formato de descripcion incorrecto
                      </span>
                    </div>
                  </div>
                </div>
                <div className="pds-form-field">
                  <fieldset className="pds-form-radio-fieldset">
                    <legend className="pds-form-radio-legend">
                      <strong>Clasificación</strong>
                    </legend>
                    <div className="pds-radio">
                      <input
                        name="pdsRadioOptions"
                        type="radio"
                        id="pdsFormValidation-pdsRadioOptions1"
                        defaultValue="public"
                        onChange={(e) =>
                          setUpload({
                            ...upload,
                            classification: e.target.value,
                          })
                        }
                      />
                      <label htmlFor="pdsFormValidation-pdsRadioOptions1">
                        Público
                      </label>
                    </div>
                    <div className="pds-radio">
                      <input
                        name="pdsRadioOptions"
                        type="radio"
                        id="pdsFormValidation-pdsRadioOptions2"
                        defaultValue="Internal"
                        onChange={(e) =>
                          setUpload({
                            ...upload,
                            classification: e.target.value,
                          })
                        }
                      />
                      <label htmlFor="pdsFormValidation-pdsRadioOptions2">
                        Privado
                      </label>
                    </div>
                    <div className="pds-radio">
                      <input
                        name="pdsRadioOptions"
                        type="radio"
                        id="pdsFormValidation-pdsRadioOptions3"
                        defaultValue="ConfidentialClient"
                        onChange={(e) =>
                          setUpload({
                            ...upload,
                            classification: e.target.value,
                          })
                        }
                      />
                      <label htmlFor="pdsFormValidation-pdsRadioOptions3">
                        Confidencial del Cliente
                      </label>
                    </div>
                    <div className="pds-radio">
                      <input
                        name="pdsRadioOptions"
                        type="radio"
                        id="pdsFormValidation-pdsRadioOptions4"
                        defaultValue="ConfidentialCompany"
                        onChange={(e) =>
                          setUpload({
                            ...upload,
                            classification: e.target.value,
                          })
                        }
                      />
                      <label htmlFor="pdsFormValidation-pdsRadioOptions4">
                        Confidencial de la compañía
                      </label>
                    </div>
                  </fieldset>
                </div>
                <div>
                  {renderMetadataFilters()}
                </div>
                <div className="pds-form-ctas">
                  <button
                    className="pds-button pds-button-primary"
                    id="btn-send-upload"
                    onClick={(e) => handleSubmit(e, setinputList)}
                  >
                    Enviar
                  </button>
                </div>
              </form>
            </div>
          </dl>
        </div>
      </div>
    </div>
  );
};

export default UploadDocument;
